import { toast as originalToast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ToastSuccess from './success';
import ToastError from './error';

const GLOBAL_ERROR_TOAST_ID = 'global-error-toast';
const ERROR_TOAST_BLOCKED_AUTH_ROUTES = [
  '/login',
  '/forgot-password',
  '/forgot-username',
  '/forgotten-user-id',
  '/show-username',
  '/check-email',
  '/confirmed-new-link',
  '/confirmed-new-invite',
  '/change-password',
  '/mfa-verification',
  '/password-changed-success',
  '/portal/selection',
  '/store-selection',
];

const shouldSuppressErrorToast = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  const normalizedPathname = window.location.pathname.replace(/\/$/, '') || '/';
  return ERROR_TOAST_BLOCKED_AUTH_ROUTES.includes(normalizedPathname);
};

// Custom toast function
export const toast = (message, type, autoClose = {}) => {
  switch (type) {
    case 'success':
      return originalToast(<ToastSuccess message={message} />, autoClose );
    case 'error':
      if (shouldSuppressErrorToast()) {
        if (originalToast.isActive(GLOBAL_ERROR_TOAST_ID)) {
          originalToast.dismiss(GLOBAL_ERROR_TOAST_ID);
        }
        return null;
      }
      if (originalToast.isActive(GLOBAL_ERROR_TOAST_ID)) {
        return originalToast.update(GLOBAL_ERROR_TOAST_ID, {
          ...autoClose,
          render: <ToastError message={message} />,
        });
      }
      return originalToast(<ToastError message={message} />, {
        ...autoClose,
        toastId: GLOBAL_ERROR_TOAST_ID,
      });
    // Add cases for other types if needed
    default:
        console.log("default case")
  }
};